import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TopicComponent} from './topic/topic.component';
import {ExercisesComponent} from './exercises/exercises.component';
import {CompletePatternComponent} from './complete-pattern/complete-pattern.component';
import {CompletePatternTwoPlayerComponent} from './complete-pattern-two-player/complete-pattern-two-player.component';
import {CountPatternComponent} from './count-pattern/count-pattern.component';


const dataRepresentationRoutes: Routes = [
  { path: 'pattern', component: TopicComponent,
    children : [
      { path: '', component: ExercisesComponent, pathMatch: 'full'},
      { path: 'complete-pattern/:id', component: CompletePatternComponent},
      { path: 'complete-pattern-two-player/:id', component: CompletePatternTwoPlayerComponent},
      { path: 'count-pattern/:id', component: CountPatternComponent}
    ] },
];

@NgModule({
  imports: [
    RouterModule.forChild(dataRepresentationRoutes)
  ],
  declarations: [],
  exports: [
    RouterModule]
})
export class TopicRoutingModule { }
